import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MessageCircle, X } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";

/** Floating chat launcher that appears on every page (except /login, /marketing, /reset-password).
 *  Shows unread chat count; clicking routes to /messaging. */
export default function FloatingChat() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [unread, setUnread] = useState(0);
  const [pulse, setPulse] = useState(false);

  useEffect(() => {
    if (!user) return;
    const load = async () => {
      try {
        const r = await api.get("/v2/channels");
        const sum = (r.data || []).reduce((s, c) => s + (c.unread || 0), 0);
        setUnread(prev => { if (sum > prev) setPulse(true); setTimeout(() => setPulse(false), 900); return sum; });
      } catch {}
    };
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, [user]);

  if (!user) return null;
  if (window.location.pathname.startsWith("/messaging")) return null;

  return (
    <button
      onClick={() => nav("/messaging")}
      className={`hidden lg:flex fixed bottom-5 right-5 z-40 w-14 h-14 rounded-full bg-gradient-to-br from-cyan-500 via-cyan-600 to-sky-600 text-white shadow-[0_12px_32px_-8px_rgba(6,182,212,0.5)] hover:scale-110 hover:shadow-[0_18px_40px_-8px_rgba(6,182,212,0.65)] transition-all duration-300 items-center justify-center group ${pulse ? "animate-bounce" : ""}`}
      data-testid="floating-chat"
      aria-label="Open chat"
    >
      <span className="absolute inset-0 rounded-full bg-cyan-400/30 animate-ping" />
      <MessageCircle className="w-6 h-6 relative z-10" strokeWidth={2} />
      {unread > 0 && (
        <span className="absolute -top-1 -right-1 bg-rose-500 text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1 border-2 border-white">
          {unread > 99 ? "99+" : unread}
        </span>
      )}
    </button>
  );
}
